import React, { useState, useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography, Modal, notification } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { Link, useNavigate } from "react-router-dom";
import {
  faCheckCircle,
  faExclamationCircle,
  faUserLock,
} from "@fortawesome/free-solid-svg-icons";
import SkeltonList from "../../../components/SkeltonEffect/list";
import Pagination from "@mui/material/Pagination";
import * as XLSX from 'xlsx';
import {createWinners} from "../../../controllers/V1/analyserControllers";
import { sentReVerifyOtp, verifyOtp } from "../../../controllers/accounts/Account";
import moment from 'moment';
import {usePermissions} from "../../../controllers/PermissionContext";
const PreviewPopUp = ({ popUpOpen, togglePopUp, usersDetails=[], campaignData={}, matchingCode="", otherData={} }) => {
  const navigate = useNavigate();
  const handleCancel = () => {
    togglePopUp([]);
    setCurrentRows([]);
    setTotalPages(0);
    setGameType("");
    setWinningNumber("");
    setTotalWinners(0);
    setWinningAmount(0)
    setTwoFactorVerify(false);
    resetOtpState();
    submitInProgressRef.current = false;
  }
  const [twoFactorVerify, setTwoFactorVerify] = useState(false);
  const [isOtpPopup, setOtpPopup] = useState(false);
  const [isOtpSubmitting, setIsOtpSubmitting] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(60);
  const [isOtpCounting, setIsOtpCounting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const submitInProgressRef = useRef(false);
  const otpRef = useRef(null);
  const PERMISSION = usePermissions("analyser");

  const resetOtpState = () => {
    setOtpPopup(false);
    setIsOtpSubmitting(false);
    setOtpCountdown(60);
    setIsOtpCounting(false);
  };

  const[ jsonData, setJsonData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [start, setStart] = useState(0);
  const [currentRowsData, setCurrentRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [countData, setCountData] = useState({});
  const [searchValue, setSearchValue]=useState("");

  const [gameType, setGameType] = useState("");
  const [winningNumber, setWinningNumber] = useState("");
  const [totalWinners, setTotalWinners] = useState(0);
  const [winningAmount, setWinningAmount] = useState(0);
  const [totalTickets, setTotalTickets] = useState(0);
  const [totalSales, setTotalSales] = useState(0);

  useEffect(()=>{
    setJsonData(usersDetails);
    const start = (currentPage - 1) * rowsPerPage;
    const currentRows = usersDetails.slice(start, start + rowsPerPage);
    const totalPages = Math.ceil(usersDetails?.length / rowsPerPage);
    setStart(start);
    setCurrentRows(currentRows);
    setTotalPages(totalPages);
    //Set Game Details
    setGameType(campaignData?.title);
    setWinningNumber(matchingCode);
    setTotalWinners(usersDetails?.length);
    const totalWinningAmount = usersDetails.reduce((sum, item) => sum + item["WINNING AMOUNT"], 0);
    setWinningAmount(totalWinningAmount || 0);
    //End

  },[usersDetails?.length]);

  useEffect(()=>{
    setTotalTickets(otherData?.total_ticket || 0);
    setTotalSales(otherData?.total_sales || 0);
  },[otherData?.total_ticket, otherData?.total_sales])

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);

    const start = (newPage - 1) * rowsPerPage;
    const currentRows = jsonData.slice(start, start + rowsPerPage);

    setStart(start);
    setCurrentRows(currentRows);
  };

  const exportToExcel = async () => {
    try {
      if(jsonData && jsonData?.length > 0) {
        const workbook = XLSX.utils.book_new();
        const worksheet1 = XLSX.utils.json_to_sheet(jsonData);
  
        XLSX.utils.book_append_sheet(workbook, worksheet1, "Winner's List");
        
        XLSX.writeFile(workbook, `Winner-${gameType}-${winningNumber}-${moment().format('YYYY-MM-DD')}.xlsx`);
      } else{
        alert("No data found to export!");
      }
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      let filteredData = [...jsonData];
      // Perform search
      if (searchValue.trim() !== "") {
        const lowerQuery = searchValue.toLowerCase();
        filteredData = filteredData.filter(item =>
          Object.values(item).some(value =>
            String(value).toLowerCase().includes(lowerQuery)
          )
        );
      }
      setCurrentPage(1)
      const start = (1 - 1) * rowsPerPage;
      const currentRows = filteredData.slice(start, start + rowsPerPage);
      const totalPages = Math.ceil(filteredData?.length / rowsPerPage);
      setStart(start);
      setCurrentRows(currentRows);
      setTotalPages(totalPages);

    } catch (error) {
      console.log('error : ', error);
    }
  }

  const submitWinners = async () => {
    if (submitInProgressRef.current || isLoading) return;

    submitInProgressRef.current = true;
    setIsLoading(true);
    try {
      if(usersDetails && usersDetails.length > 0){
        const option = {
          param : usersDetails,
          game_name : gameType,
          winningNumber : winningNumber
        }
        // console.log("option : ", option);
        // const res = {status : true};
        // return res;
        const res = await createWinners(option);
        if(res.status === true){
          handleCancel();
          Modal.success({
            title: "Success",
            content: "Winners uploaded successfully..",
            okText: "OK",
            afterClose: () => navigate("/analyser"),
          });
        } else{
          notification.open({
            message: "Error",
            description: `${res?.message}`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon
                icon={faExclamationCircle}
                style={{ color: "red" }}
              />
            ),
            duration: 2,
          });
        }
      }else{
        notification.open({
          message: "Error",
          description: `No winner found!`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ color: "red" }}
            />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
      submitInProgressRef.current = false;
    }
  };

  const handleOtpCancel = () => {
    if (isOtpSubmitting || isLoading) return;
    resetOtpState();
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (isOtpSubmitting || submitInProgressRef.current || isLoading) return;

    setIsOtpSubmitting(true);
    try {
      const formData = new FormData(e.target);
      const otp = formData.get("otp");
      const res = await verifyOtp({ otp });
      if (res.status === true) {
        notification.open({
          message: "Success",
          description: "User verify successfully. Please continue you task.",
          placement: "topRight",
          icon: (
            <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />
          ),
          duration: 2,
        });
        setTwoFactorVerify(true);
        resetOtpState();
        await submitWinners();
      } else {
        notification.open({
          message: "Oops!",
          description: "Entered OTP is expired/wrong. Please try again.",
          placement: "topRight",
          icon: (
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ color: "red" }}
            />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsOtpSubmitting(false);
    }
  };

  const handleResendOtp = async () => {
    if (isOtpSubmitting) return;

    try {
      const res = await sentReVerifyOtp();
      if (res.status === true) {
        notification.open({
          message: "Success",
          description: "One Time Password (OTP) is sent successfully.",
          placement: "topRight",
          icon: (
            <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />
          ),
          duration: 2,
        });
        setOtpCountdown(60);
        setIsOtpCounting(true);
      } else {
        notification.open({
          message: "Oops!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ color: "red" }}
            />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (isOtpPopup === true && isOtpCounting === false) {
      sentReVerifyOtp();
      setOtpCountdown(60);
      setIsOtpCounting(true);
    }
  }, [isOtpPopup]);

  useEffect(() => {
    let countdownInterval;
    if (isOtpCounting) {
      countdownInterval = setInterval(() => {
        setOtpCountdown((prevCountdown) => {
          if (prevCountdown > 0) {
            return prevCountdown - 1;
          }
          setIsOtpCounting(false);
          return 0;
        });
      }, 1000);
    }
    return () => {
      clearInterval(countdownInterval);
    };
  }, [isOtpCounting]);

  const handleUpload = async () => {
    if (isLoading || isOtpSubmitting || submitInProgressRef.current) return;

    if (twoFactorVerify === false) {
      if (!isOtpPopup) setOtpPopup(true);
      return;
    }
    await submitWinners();
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"xl"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading" >
            {gameType || ""} Winner's List
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form>
                <div className="form-group row">
                  <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                    <input type="text" name="name" id="name" onChange={(e)=>setSearchValue(e.target.value)} placeholder="Search ticket, seller's name, mobile number, coupon, ..." className="form-control categories_select_tg_enter_product" />

                  </div>
                  
                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                    <button type="button" className="btn btn-danger" onClick={handleSearch}> Search </button>
                  </div>
                  {(PERMISSION?.fullAccess === "Y" || PERMISSION?.upload === "Y") && (
                    <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                      <button type="button" className="btn btn-danger" onClick={handleUpload} disabled={isLoading || isOtpSubmitting || isOtpPopup}> {isLoading === true ? `Uploading...` : `Upload Winners`} </button>
                    </div>
                  )}

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Game Type : {gameType || "N/A" }</h4>
                  </div>  

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Winning no. : {winningNumber || "N/A"}</h4>
                  </div>  

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Total Winners : {totalWinners || ""}</h4>
                  </div>  

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Total Winning Amount : {winningAmount || 0}</h4>
                  </div> 

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Total Tickets : {totalTickets || 0}</h4>
                  </div> 

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Total Sales : {totalSales || 0}</h4>
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <h4>Draw Date : {otherData?.draw_date || "N/A"}</h4>
                  </div> 

                  <div id="content-wrapper" className="d-flex flex-column">
                    <div className="card shadow mb-4">
                      <div className="card-body pt-0">
                        <div className="table-responsive">
                          <table
                            className="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th>SL. NO.</th>
                                <th>TICKET ID</th>
                                <th>SELLER FIRST NAME</th>
                                <th>SELLER LAST NAME</th>
                                <th>SELLER MOBILE</th>
                                <th>COUPONS</th>
                                <th>STRAIGHT AMOUNT</th>
                                <th>RUMBLE AMOUNT</th>
                                <th>CHANCE AMOUNT</th>
                                <th>WINNER TYPE</th>
                                <th>WINNING AMOUNT</th>
                                <th>MATCHING NUMBER</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentRowsData?.length > 0 ? (
                                currentRowsData.map((items, index) => (
                                  <>
                                    <tr key={index} onClick={()=> console.log(items)} >
                                      <td> {start + index + 1} </td>
                                      <td>{items['TICKET ID']}</td>
                                      <td>{items['SELLER FIRST NAME']} </td>
                                      <td>{items['SELLER LAST NAME']}</td>
                                      <td>{items['SELLER MOBILE']}</td>
                                      <td>{items['COUPONS']}</td>
                                      <td>{items['STRAIGHT AMOUNT']}</td>
                                      <td>{items['RUMBLE AMOUNT']}</td>
                                      <td>{items['CHANCE AMOUNT']}</td>
                                      <td>{items['WINNER TYPE']}</td>
                                      <td>{items['WINNING AMOUNT']}</td>
                                      <td>{items['MATCHING NUMBER']}</td>
                                    </tr>
                                  </>
                                ))
                              ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                                  <td colspan="8" className="img-center" >No data found !</td> 
                              </tr>}
                            </tbody>
                          </table>
                          {totalPages > 0 && (
                            <div className="table_pagination_sales_order">
                              <Pagination
                                count={parseInt(totalPages)}
                                onChange={handlePageChange}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" style={{width : '300px'}} onClick={handleCancel}>Cancel</button>
                      {(PERMISSION?.fullAccess === "Y" || PERMISSION?.export === "Y") && (
                        <button type="button" className="btn btn-danger" style={{width : '300px'}} onClick={exportToExcel} disabled={isLoading}> Export</button>
                      )}
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Dialog
        open={isOtpPopup}
        onClose={handleOtpCancel}
        fullWidth={false}
        maxWidth={"sm"}
        PaperProps={{
          className: "myDialogPopUp",
        }}
      >
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Link
              to={false}
              style={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "#dd5151",
                fontSize: "2rem",
              }}
              onClick={handleOtpCancel}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleOtpSubmit}>
                  <div className="form-group row">
                    <div
                      className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                      style={{ textAlign: "center" }}
                    >
                      <label
                        htmlFor="otp"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        <FontAwesomeIcon
                          icon={faUserLock}
                          style={{ color: "gray", fontSize: "5rem" }}
                        />
                      </label>
                      <h4 className="all_lable_for_vendor_dashbaord">
                        For your security, please verify your identity by entering
                        the OTP sent to your registered email.
                      </h4>
                    </div>

                    <div
                      className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                      style={{ textAlign: "center" }}
                    >
                      <input
                        type="number"
                        name="otp"
                        id="otp"
                        ref={otpRef}
                        className="form-control store_input_field"
                        placeholder="Enter your One Time Password (OTP)"
                        disabled={isOtpSubmitting}
                      />
                    </div>

                    <div
                      className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                      style={{ textAlign: "center" }}
                    >
                      <label className="all_lable_for_vendor_dashbaord">
                        Didn't receive the code?{" "}
                        {isOtpCounting ? (
                          <Link>[ Resend OTP in {otpCountdown || 0} ]</Link>
                        ) : (
                          <Link to="#" onClick={handleResendOtp}>
                            [ Resend OTP ]
                          </Link>
                        )}
                      </label>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div
                        className="inventory_open_popup_action_btn"
                        style={{ justifyContent: "center" }}
                      >
                        <button
                          type="submit"
                          className="btn btn-danger"
                          disabled={isOtpSubmitting || isLoading}
                        >
                          {isOtpSubmitting ? "Submitting..." : "Submit"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-light categories_cancel_button"
                          onClick={handleOtpCancel}
                          disabled={isOtpSubmitting || isLoading}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </Dialog>
    </Dialog>
  );
};

export default PreviewPopUp;
